
import RugbyHeader from '../components/header/rugby-header'


import './rugby-news.css'

const RugbyNews = () => {
    return (
        <>
            <RugbyHeader />
            <div className='news'></div>
        </>

    );
}


export default RugbyNews;